const introVideo = document.querySelector('.intro-video');

if (introVideo) {
  const desktopVideo = introVideo.querySelector('.intro-video__video-container.desktop');
  const mobileVideo = introVideo.querySelector('.intro-video__video-container.mobile');
  const startButton = introVideo.querySelector('.intro-video__start');
  const content = introVideo.querySelector('.intro-video__content');
  const images = introVideo.querySelectorAll('.intro-video__image');

  const isMobile = windowWidth() <= breakpointMd;
  const video = isMobile ? mobileVideo : desktopVideo;

  video.controls = false;
  video.pause();

  toggleBodyScrollLock(true);

  startButton.addEventListener('click', () => {
    content.classList.add('is-hidden');

    setTimeout(() => {
      video.play();
      images.forEach((image) => {
        image.classList.add('is-hidden');
      });

      const duration = video.duration * 1000;
      const timeoutBeforeEnd = duration - 1000;

      setTimeout(() => {
        document.body.classList.add('is-loaded');
      }, timeoutBeforeEnd);

      video.addEventListener(
        'ended',
        () => {
          introVideo.classList.add('is-hidden');
          toggleBodyScrollLock(false);
        },
        { once: true },
      );
    }, 500);
  });
}
